import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Phone, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { CONTACT } from "@/lib/api";

const NAV = [
  { to: "/modelle", key: "models" },
  { to: "/galerie", key: "gallery" },
  { to: "/flotten", key: "fleet" },
  { to: "/kontakt", key: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-1 shrink-0">
          <span className="font-display font-extrabold tracking-tight text-xl md:text-2xl text-[#0A2540]">
            SKYWORTH<span className="text-[#0052CC]">CARS</span>
          </span>
          <span className="text-xs font-semibold text-slate-500">.ch</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="main-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.key}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[#0052CC] ${
                  isActive ? "text-[#0A2540]" : "text-slate-600"
                }`
              }
            >
              {t(`nav.${n.key}`)}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href={CONTACT.phoneHref}
            data-testid="header-phone-btn"
            className="flex items-center gap-2 text-sm font-semibold text-[#0A2540] hover:text-[#0052CC] transition-colors"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phone}
          </a>
          <Button asChild className="rounded-md bg-[#0A2540] hover:bg-slate-800 text-white px-6 py-3">
            <Link to="/probefahrt" data-testid="header-test-drive-btn">{t("cta.testDrive")}</Link>
          </Button>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <button data-testid="mobile-menu-btn" aria-label="Menü öffnen" className="p-2 text-[#0A2540]">
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-white w-72">
            <nav className="flex flex-col gap-6 mt-10">
              {NAV.map((n) => (
                <Link
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  className="text-lg font-semibold text-[#0A2540]"
                >
                  {t(`nav.${n.key}`)}
                </Link>
              ))}
              <LanguageSwitcher />
              <Button asChild className="rounded-md bg-[#0A2540] text-white mt-4">
                <Link to="/probefahrt" onClick={() => setOpen(false)} data-testid="mobile-test-drive-btn">
                  {t("cta.testDrive")}
                </Link>
              </Button>
              <a href={CONTACT.phoneHref} className="flex items-center gap-2 text-sm font-semibold text-slate-600">
                <Phone className="w-4 h-4" /> {CONTACT.phone}
              </a>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
